import React, { useState } from 'react';
import Breadcumb from '../../Layouts/Breadcumb';
import { Grid, TextField } from '@mui/material';
import DashboardNav from './DashboardNav';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { jwtDecode } from 'jwt-decode';
import { Constants } from '../../endPoints';

const MySwal = withReactContent(Swal);

const Changedpassword = () => {
  const [initialValues] = useState({
    current_password: '',
    new_password: '',
    confirm_new_password: '',
  });

  const validationSchema = Yup.object().shape({
    current_password: Yup.string().required('Current password is required'),
    new_password: Yup.string()
      .min(6, 'New password must be at least 6 characters')
      .required('New password is required'),
    confirm_new_password: Yup.string()
      .oneOf([Yup.ref('new_password'), null], 'Passwords must match')
      .required('Please confirm your new password'),
  });

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const token = localStorage.getItem('authToken');
      const decoded = jwtDecode(token);
      const idUser = decoded.id;

      const response = await axios.post(
        `${Constants.changedPassword}`,
        {
          idUser,
          current_password: values.current_password,
          new_password: values.new_password,
        }
      );

      if (response.data.status === 1) {
        MySwal.fire('Success', 'Password changed successfully', 'success');
        resetForm();
      } else {
        MySwal.fire('Error', response.data.message, 'error');
      }
    } catch (error) {
      console.error('Password change error:', error);
      MySwal.fire('Error', error.response?.data?.message || 'Something went wrong', 'error');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Breadcumb pagetitle="Change Password" />
      <section className="dashboardsec">
        <div className="container mx-auto px-4">
          <Grid container spacing={5}>
            <Grid item lg={3} md={12} sm={12} xs={12}>
              <DashboardNav />
            </Grid>
            <Grid item lg={9} md={12} sm={12} xs={12}>
              <h4 className="text-2xl font-normal mb-5">Change Password</h4>
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({ isSubmitting }) => (
                  <Form className="form-password">
                    <Grid container spacing={3}>
                      <Grid item lg={5} md={6} sm={12}>
                        <Field
                          name="current_password"
                          as={TextField}
                          type="password"
                          label="Current Password"
                          variant="outlined"
                          fullWidth
                        />
                        <ErrorMessage name="current_password" component="div" className="text-red-500 text-sm" />
                      </Grid>
                      <Grid item lg={5} md={6} sm={12}>
                        <Field
                          name="new_password"
                          as={TextField}
                          type="password"
                          label="New Password"
                          variant="outlined"
                          fullWidth
                        />
                        <ErrorMessage name="new_password" component="div" className="text-red-500 text-sm" />
                      </Grid>
                      <Grid item lg={5} md={6} sm={12}>
                        <Field
                          name="confirm_new_password"
                          as={TextField}
                          type="password"
                          label="Confirm New Password"
                          variant="outlined"
                          fullWidth
                        />
                        <ErrorMessage name="confirm_new_password" component="div" className="text-red-500 text-sm" />
                      </Grid>
                    </Grid>

                    <div className="mt-5">
                      <button
                        type="submit"
                        className="h-14 submit_btn px-8 border rounded bg-[#b3902d] min-w-32 text-white font-semibold"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? 'Updating...' : 'Update Password'}
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </Grid>
          </Grid>
        </div>
      </section>
    </>
  );
};

export default Changedpassword;
